<dx-data-grid [dataSource]="dataSource"
              [showBorders]="true"
              [columns]="columns"
              [columnAutoWidth]="true">
  <dxo-editing mode="batch"
               [allowDeleting]="true"
               [allowUpdating]="true"></dxo-editing>
  <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
  <div *dxTemplate="let item of 'detail'">
    <app-admin-user-task-detail [data]="item"></app-admin-user-task-detail>
  </div>
</dx-data-grid>
